.nearbyStores {
  display: block;
  overflow-y: scroll;
  flex: 1;
  margin-top: 24px;
  padding-left: 16px;
  padding-right: 16px;
}

.nearbyStores::-webkit-scrollbar {
  display: none;
}

.storesRow {
  margin-bottom: 100px;
}

.storesRow::-webkit-scrollbar {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .nearbyStores {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 80px; /* Height of close button */
  }

  .storesRow {
    margin-bottom: 0;
  }
}
